import { v7 as uuidv7 } from "uuid";

/**
 * UUID v7: time-sortable, sync-friendly. Used for every persisted record.
 */
export function newId(): string {
  return uuidv7();
}
